import ct from "class-types.macro";
import React, { useState } from "react";
import { connect } from "react-redux";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
import PlatinumPlusExclusive from "~/productListing/ProductBox/PlatinumPlusExclusive";
import AddToCart from "~/productListing/ProductBox/AddToCart";
import isNonExclusiveForPlatinumPlusProduct from "~/productListing/ProductBox/isNonExclusivePlatinumPlusProduct";
import { PlusLink } from "@clarkinc/zest-design-system/ui";
interface Props {
  product: Product;
  user: UserState;
}

const RelatedProduct = ({ product, user }: Props) => {
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct>({
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
    price: {
      ...product.price,
      originalPrice:
        product.outletAttributes && product.outletAttributes.originalPrice,
    },
  });

  return (
    <div
      className="ag-item"
      key={`video-product_${product.itemNumber}`}
      gtm-tracking-number={product.itemNumber}
    >
      <div className="product-image">
        <a href={product.link} title={product.description}>
          <img alt={product.description} src={product.primaryImagePath} />
        </a>
      </div>
      <div>
        <a className="description" href={product.link}>
          {product.descriptionHtml}
        </a>
        <div className="pricing" data-component="Pricing">
          <p className="price">
            {product.isWebstaurantPlusEligible && (
              <PlusLink
                className="mr-0.5 relative top-0.5"
                data-testid={`plus-link-${product.description}`}
              />
            )}
            <PlatinumPlusExclusive
              user={user}
              customerExclusivity={product.customerExclusivity}
            />
            <span className="price-container">
              {`${formatAsCurrency.formatIfUndefined(product.price.price)}`}
            </span>
            <span className="each uom">/{product.unitOfMeasure}</span>
          </p>
        </div>
        {isNonExclusiveForPlatinumPlusProduct(
          product.customerExclusivity,
          user,
        ) && (
          <div>
            <AddToCart
              {...{
                product,
                user,
                selectedProduct,
                setSelectedProduct,
                isCarouselProductBox: true,
                outOfStockStyle: ct(
                  "font-semibold",
                  "text-base",
                  "leading-none",
                  "relative",
                  "text-center",
                  "text-red-400",
                ),
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const mapStateToProps = (state: RootState) => ({ user: state.user });

export default connect(mapStateToProps)(RelatedProduct);
